import { createFileRoute } from '@tanstack/react-router';

import { NewInvitationPage } from '../features/team/team-pages';

export const Route = createFileRoute('/manage/$companySlug/settings/invitations_/new')({
  component: NewInvitationRoute,
});

function NewInvitationRoute() {
  const { companySlug } = Route.useParams();
  return <NewInvitationPage companySlug={companySlug} />;
}
